import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import AddSemisterForm from "../../components/AddSemisterForm/AddSemisterForm";
import Layout from "../../components/shared/Layout/Layout";

const AddSemisterPage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Semister Result`}>
        {edit && id && grades ? (
          <AddSemisterForm edit={true} grades={grades} />
        ) : (
          <AddSemisterForm grades={grades ? grades : []} />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddSemisterPage);
